import { service } from '@ember/service';
import SubjectController from './subject';

export default class PlpController extends SubjectController {
  @service
  strings;

  isPLP = true;
}
